import { render, staticRenderFns } from "./AnnounceDetails.vue?vue&type=template&id=3a505904&scoped=true&"
import script from "./AnnounceDetails.vue?vue&type=script&lang=js&"
export * from "./AnnounceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a505904",
  null
  
)

export default component.exports